import { Button, Card, Space, Spin, Typography } from 'antd'
import React, { memo } from 'react'
import { Link } from 'react-router'

export interface ApplicationCardProps {
  assignee: string
  count: number
  isLoading: boolean
}

const ApplicationGridCard = ({
  assignee,
  count,
  isLoading,
}: ApplicationCardProps) => {
  return (
    <Card
      style={{
        width: '350px',
      }}
    >
      {isLoading ? <AppQueueCardLoading /> : null}
      <Space
        style={{
          width: '100%',
          justifyContent: 'space-between',
          position: 'relative',
        }}
      >
        <div>
          <Typography.Text>{assignee}</Typography.Text>
          <Typography.Text style={{ color: 'gray', paddingLeft: '4px' }}>
            ({count})
          </Typography.Text>
        </div>
        <div>
          <Link
            to={`/application-engine?assignee=${encodeURIComponent(assignee)}`}
          >
            <Button disabled={count === 0} type="primary">
              Review
            </Button>
          </Link>
        </div>
      </Space>
    </Card>
  )
}

const AppQueueCardLoading = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        zIndex: 1,
      }}
    >
      <Spin />
    </div>
  )
}

export default memo(ApplicationGridCard)
